import React from 'react';
import propTypes from 'prop-types';

export const FaxIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      viewBox="0 0 24 24"
      version="1.1"
      fill={color}
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity={1}
          d="M 22.5 7.5 L 22.5 3.621094 C 22.5 3.222656 22.34375 2.84375 22.0625 2.5625 L 19.9375 0.4375 C 19.65625 0.15625 19.277344 0 18.878906 0 L 7.5 0 C 6.671875 0 6 0.671875 6 1.5 L 6 22.5 C 6 23.328125 6.671875 24 7.5 24 L 22.5 24 C 23.328125 24 24 23.328125 24 22.5 L 24 9 C 24 8.171875 23.328125 7.5 22.5 7.5 Z M 13.5 20.25 C 13.5 20.664062 13.164062 21 12.75 21 L 11.25 21 C 10.835938 21 10.5 20.664062 10.5 20.25 L 10.5 18.75 C 10.5 18.335938 10.835938 18 11.25 18 L 12.75 18 C 13.164062 18 13.5 18.335938 13.5 18.75 Z M 13.5 14.25 C 13.5 14.664062 13.164062 15 12.75 15 L 11.25 15 C 10.835938 15 10.5 14.664062 10.5 14.25 L 10.5 12.75 C 10.5 12.335938 10.835938 12 11.25 12 L 12.75 12 C 13.164062 12 13.5 12.335938 13.5 12.75 Z M 19.5 20.25 C 19.5 20.664062 19.164062 21 18.75 21 L 17.25 21 C 16.835938 21 16.5 20.664062 16.5 20.25 L 16.5 18.75 C 16.5 18.335938 16.835938 18 17.25 18 L 18.75 18 C 19.164062 18 19.5 18.335938 19.5 18.75 Z M 19.5 14.25 C 19.5 14.664062 19.164062 15 18.75 15 L 17.25 15 C 16.835938 15 16.5 14.664062 16.5 14.25 L 16.5 12.75 C 16.5 12.335938 16.835938 12 17.25 12 L 18.75 12 C 19.164062 12 19.5 12.335938 19.5 12.75 Z M 19.5 9 L 9 9 L 9 3 L 16.5 3 L 16.5 5.25 C 16.5 5.664062 16.835938 6 17.25 6 L 19.5 6 Z M 3 6 L 1.5 6 C 0.671875 6 0 6.671875 0 7.5 L 0 22.5 C 0 23.328125 0.671875 24 1.5 24 L 3 24 C 3.828125 24 4.5 23.328125 4.5 22.5 L 4.5 7.5 C 4.5 6.671875 3.828125 6 3 6 Z M 3 6 "
        />
      </g>
    </svg>
  );
};
FaxIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
FaxIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
